import Vue from "vue";
import router from "./router";
import Icon from "@/components/Icon.vue";
import SpiMarker from "@/components/SpiMarker.vue";
import AdhocMarker from "@/components/AdhocMarker.vue";
import LtIcon from "@/components/LtIcon.vue";
import Counter from "@/components/Counter.vue";
import { attachRouter } from "./state.init";
import { SharedState } from "@/common/state";
import "./common/filters.global";
import axios, { AxiosError } from "axios";
import { apiErrHandler } from "./common/api/err.handler";
import { identity, isNotEmpty, has_prop, path } from "./fp";
import App from "./App.vue";
import { apiCall } from "./common/api/ApiResult.model";
import { LoggedUser } from "./common/models";
import "./theme";
import "@/components/root/tooltip/tooltip.directive";

import { init_mocking } from "./mock/api";
import EmptyCell from "@/components/EmptyCell.vue";
import { env } from "./env";
import { UseModal } from "./components/root/modal";
import { BackDoor } from "./backdoor";
import { UserStorage } from "./storage";
import { lorem_ipsum } from "./mock/api/utils";
axios.interceptors.response.use(identity, function (error) {
  apiErrHandler(error as AxiosError);
  return Promise.reject(error);
});
// @ts-ignore
window.getBaseUrl = () => axios.defaults.baseURL;

Vue.config.productionTip = false;

Vue.component("Icon", Icon);
Vue.component("SpiMarker", SpiMarker);
Vue.component("AdhocMarker", AdhocMarker);
Vue.component("LtIcon", LtIcon);
Vue.component("Counter", Counter);
Vue.component("EmptyCell", EmptyCell);

Vue.prototype.$isNotEmpty = isNotEmpty;
Vue.prototype.$has_prop = has_prop;

(async () => {
  const env_val = await env();
  Vue.prototype.$env = env_val;
  const the_router = router(env_val);
  attachRouter(the_router);
  init_mocking(env_val, env_val.mock);
  await SharedState.before_init_app(env_val);
  Vue.prototype.$copy = (text: string) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    }
  };
  Vue.prototype.$edition = () => SharedState.paymentEdition.value;
  (Vue.prototype.$is_int = (n: any) => Number.isInteger(n)),
    (Vue.prototype.$is_biz_user = () => SharedState.is_biz_user.value);
  Vue.prototype.$is_mock = () => env_val.mock;
  Vue.prototype.$x_words = BackDoor.x_words;
  Vue.prototype.$lorem_ipsum = (n: number) => lorem_ipsum(n);
  Vue.prototype.$theme = SharedState.theme;
  Vue.prototype.$path = path;
  Vue.prototype.$is_regulated = (id: string) => {
    const label = SharedState.allInfoTypes.value[id];
    if (label) {
      return label.regulationType !== "None";
    } else {
      return false;
    }
  };
  // Adhoc
  Vue.prototype.$is_adhoc = (id: string) => {
    const label = SharedState.allInfoTypes.value[id];
    if (label) {
      return label.labelType === "Adhoc";
    } else {
      return false;
    }
  };

  SharedState.init(env_val);
  UseModal().set_router(the_router);
  new Vue({
    router: the_router,
    render: (h) => h(App),
  }).$mount("#app");
})();

//#region referesh token
const refreshToken = apiCall<void, boolean>("refreshtoken", async () => {
  const res = await axios.get("/refreshtoken");
  try {
    const user: LoggedUser = SharedState.loggedUser.value;
    user.authorization = "Bearer " + res.data;
    axios.defaults.headers.authorization = user.authorization;
    SharedState.setLoggedUser({
      ...user,
    });
    UserStorage.save(user);
  } catch (e) {
    console.log("refreshToken error : ", e);
  }
  return {
    success: true,
    value: true,
  };
});
//#endregion

// refresh the token after a few secondes to prevent a case where
// the user is reloading the page when 20min haven't passed yet
// so we didn't change the token.
SharedState.onReady(async () => {
  await refreshToken();
});

setInterval(async () => {
  await refreshToken();
}, 1000 * 60 * 15 /* 15MIN */);

// @ts-ignore
window.show_confetti = () => {
  const burst = () => {
    const myCanvas = document.querySelector("#confetti-canvas");
    // @ts-ignore
    const myConfetti = window.confetti.create(myCanvas, {
      resize: true,
      useWorker: true,
    });
    myConfetti({
      particleCount: 200,
      spread: 260,
    });
  };
  // @ts-ignore
  if (!window.confetti) {
    const script_el = document.createElement("script");
    script_el.src =
      "https://cdn.jsdelivr.net/npm/canvas-confetti@1.4.0/dist/confetti.browser.min.js";
    script_el.onload = () => {
      burst();
    };
    document.body.appendChild(script_el);
  } else {
    burst();
  }
};
